import SelectDetailed from 'src/components/formik-fields/selectDetailed/SelectDetailed';
import LiteralsService from 'src/services/literals/LiteralsService';
import { frequencies } from 'src/services/transaction.service';
import adobeTags from 'src/types/adobe-tags';
import React from 'react';
import styles from './transactionFrequencyCell.module.scss';

interface Props {
    baseFieldId: string;
    hideLabel?: boolean;
    isReview?: boolean;
}

export default function TransactionFrequencyCell({ baseFieldId, hideLabel, isReview }: Props): JSX.Element {
    return (
        <SelectDetailed
            id={`${baseFieldId}.frequency`}
            label={LiteralsService.getLiteral(
                hideLabel ? 'TransactionsTable.frequency.frequencySelector' : 'TransactionsTable.frequency.label'
            )}
            hideLabel={hideLabel}
            isForFrequency
            className={isReview ? styles.frequencyDropdownReview : styles.frequencyDropdown}
            options={frequencies}
            tagName={adobeTags.Transactions.Row.FrequencyDropdown}
            floatLeft
        />
    );
}
